import { render } from "./form-input-code.vue?vue&type=template&id=63af9ec7"
import script from "./form-input-code.vue?vue&type=script&lang=js"
export * from "./form-input-code.vue?vue&type=script&lang=js"

import exportComponent from "F:\\_gitProj\\zj_qd_2022\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__